module.exports = __webpack_public_path__ + "static/media/healthcare-landscape.5fc14f2b.jpg";